import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ServiceConfig } from './service-config';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AutoseedingService {

  private host = ServiceConfig.host;
  private baseUrl = this.host + '/api/auto-seeding/';
  private data: any;
  constructor(private http: HttpClient) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));

  }

  public create(body, type = 'CREATE') {
    let url = this.baseUrl + '/create-pending-config?token=' + this.data.token;
    if (type == 'RUN') {
      url = this.baseUrl + '/create-auto-seeding-config?token=' + this.data.token;
    }
    return this.http.post<any>(url, body);
  }

  public getAllTypeAccount() {
    const url = this.host + '/api/fb-user-seeding/' + '/getTypeAccount?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  
  public getAllConfigs(body) {
    const url = this.baseUrl + '/history?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public stopConfig(body) {
    const url = this.baseUrl + '/stop?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public resumeConfig(body) {
    const url = this.baseUrl + '/resume?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public startConfig(body) {
    const url = this.baseUrl + '/create-auto-seeding-config?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getDetail(body) {
    const url = this.baseUrl + '/detail?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public deleteConfig(idConfig) {
    const url = this.baseUrl + `/${idConfig}?token=` + this.data.token;
    return this.http.delete<any>(url);
  }


}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/autoseeding.service.ts